import { render, staticRenderFns } from "./modal-confirmation.html?vue&type=template&id=47b2c3f4&scoped=true&external"
import script from "./modal-confirmation.js?vue&type=script&lang=js&external"
export * from "./modal-confirmation.js?vue&type=script&lang=js&external"
import style0 from "./modal-confirmation.scss?vue&type=style&index=0&id=47b2c3f4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2c3f4",
  null
  
)

export default component.exports